/*
 * Lazy Image Recovery
 * --------------------
 * Corrige le cas où des images en loading="lazy" restent vides après que
 * l'onglet a été en arrière-plan pendant le chargement : Chrome consomme leur
 * "intention de chargement" mais suspend le fetch en background, puis ne les
 * reconsidère jamais au retour. Résultat : naturalWidth = 0, image vide définitive.
 *
 * Au retour de visibilité, on repère les images lazy restées vides et on les
 * sort du lazy (loading="eager") + on force un nouveau fetch. Une seule passe
 * par image (garde-fou data-lazy-recovered). N'agit jamais sur les images déjà
 * chargées : aucun impact en usage normal.
 */
(function () {
  function recoverLazyImages() {
    if (document.visibilityState === 'hidden') return;

    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];

      // Déjà chargée correctement → ne pas toucher.
      if (img.complete && img.naturalWidth > 0) continue;
      // Pas de source → rien à récupérer.
      var src = img.getAttribute('src');
      if (!src) continue;
      // Garde-fou : une seule tentative de récupération par image.
      if (img.dataset.lazyRecovered) continue;
      img.dataset.lazyRecovered = '1';

      // 1) Sortir du lazy : Chrome doit alors charger immédiatement.
      img.loading = 'eager';

      // 2) Ceinture + bretelles : forcer un nouveau fetch en réassignant la
      //    source (utile si le simple toggle ne suffit pas sur certaines images).
      var srcset = img.getAttribute('srcset');
      if (srcset) {
        img.setAttribute('srcset', '');
        /* reflow pour que le retrait soit pris en compte */
        void img.offsetWidth;
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('src');
        void img.offsetWidth;
        img.setAttribute('src', src);
      }
    }
  }

  document.addEventListener('visibilitychange', recoverLazyImages);
  /* Retour via cache navigateur / bouton précédent. */
  window.addEventListener('pageshow', recoverLazyImages);
})();
